import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { muiTheme } from 'cityads-v3/utils/styleUtils';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './NewYearBanner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'


export const NEW_YEAR_TAG = 'newyearsale'

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#0E92EC'
    },
  },
})

export default function NewYearBanner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [, tagsByCode] = useOfferTags()
  const offerFilters = useOfferFiltersContext()

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(NEW_YEAR_TAG)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(NEW_YEAR_TAG)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters])

  if (!tagsByCode?.[NEW_YEAR_TAG]?.is_available_in_filter) {
    return null;
  }

  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <div className={classes.text}>
            <Typography
              variant="h6"
              classes={{ root: classes.title }}
            >{t('newYear.title')}</Typography>
            <Typography>{t('newYear.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                disableElevation
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('backToSchoolBanner.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
